import { useContext } from 'react';
import { GridTasksContext, GridTasksContextValue } from '../components/grid-tasks-provider';

export const useDataGridTasks = <T extends Record<string, any> = any>() => {
  const context = useContext<GridTasksContextValue<T> | null>(GridTasksContext);
  if (!context) {
    throw new Error('useDataGridTasks must be used within a GridTasksProvider');
  }
  return context;
};  